import React, { useEffect, useRef } from 'react'
import styled from '@emotion/styled'

export default ({ exitstential, setShowModal, saveToUrlState }) => {
  const exitRef = useRef()
  const modalShown = exitstential
  // e.relatedTarget will be populated if there was another mouse event in the document before this one. when a mouse comes into the document it will be null.
  useEffect(() => {
    const onLeave = e => {
      if (e.relatedTarget) {
        !modalShown && setShowModal('Exitstitial')
        e.target.removeEventListener('mouseenter', onLeave, true)
        saveToUrlState('x', 1)
      }
    }

    if (exitRef) {
      exitRef && exitRef.current && exitRef.current.addEventListener('mouseenter', onLeave, true)
    }
  }, [setShowModal, saveToUrlState, modalShown])
  return (
    <>
      <ExitDiv ref={exitRef}></ExitDiv>
    </>
  )
}

const ExitDiv = styled.div`
  width: 100%;
  height: 20px;
  position: fixed;
  top: 0px;
  z-index: 8;
`
